import React from "react";

interface EmailVerificationSectionProps {
    isMobile: boolean;
    authorEmail: string;
    setAuthorEmail: (value: string) => void;
    emailError?: string;
    emailRef: React.RefObject<HTMLInputElement>;
    handleEmailVerification: () => void;
    emailVerificationButtonClick: boolean;
    isEmailVerified: boolean;
    emailMsg: string;
    emailVerificationCode: string;
    setEmailVerificationCode: (value: string) => void;
    codeError?: string;
    codeRef: React.RefObject<HTMLInputElement>;
    handleEmailVerificationCheck: () => void;
    isEmailCheck: boolean;
    emailCheck: string;
}

const EmailVerificationSection: React.FC<EmailVerificationSectionProps> = ({
    isMobile,
    authorEmail,
    setAuthorEmail,
    emailError,
    emailRef,
    handleEmailVerification,
    emailVerificationButtonClick,
    isEmailVerified,
    emailMsg,
    emailVerificationCode,
    setEmailVerificationCode,
    codeError,
    codeRef,
    handleEmailVerificationCheck,
    isEmailCheck,
    emailCheck,
}) => {
    return (
        <label className="flex flex-col gap-3" id="email">
            <div className="">
                <span className="title">이메일 주소</span>
            </div>
            <div className="flex-grow">
                <div
                    className={
                        isMobile ? "flex flex-row gap-2 items-center w-full" : "flex items-center"
                    }
                >
                    <input
                        ref={emailRef}
                        className={
                            isMobile
                                ? `appearance-none h-[40px] w-full text-gray-700 border ${emailError ? "border-red-500 placeholder-red-500 focus:outline-red-500" : "border-extra placeholder-gray-400 focus:outline-input"} rounded py-2 px-3 text-[13px] leading-tight focus:text-black`
                                : `appearance-none text-gray-700 border ${emailError ? "border-red-500 placeholder-red-500 focus:outline-red-500" : "border-extra placeholder-gray-400 focus:outline-input"} rounded py-3 px-4 leading-tight focus:text-black`
                        }
                        style={isMobile ? {} : { width: "100%", maxWidth: "550px", height: "38px" }}
                        type="text"
                        placeholder={emailError || "이메일을 입력하세요."}
                        value={authorEmail}
                        onChange={(e) => setAuthorEmail(e.target.value)}
                    />
                    <button
                        className={
                            isMobile
                                ? "w-[100px] h-[40px] bg-main font-namsan-B hover:bg-primary-80 border-main hover:border-primary-80 border-2 text-[13px] text-white rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-200"
                                : "w-[130px] h-[38px] bg-main ml-3 font-namsan-B hover:bg-primary-80 border-main hover:border-primary-80 border-2 text-[13px] text-white py-2 px-4 rounded-full flex items-center justify-center transition-all duration-200"
                        }
                        type="button"
                        onClick={handleEmailVerification}
                        disabled={emailVerificationButtonClick}
                    >
                        {emailVerificationButtonClick ? "전송중..." : "이메일 인증"}
                    </button>
                </div>

                {emailError && (
                    <p className="mt-2 font-namsan text-[12px] font-bold text-red-500">
                        {emailError}
                    </p>
                )}
                {isEmailVerified && (
                    <p className="mt-4 text-black font-namsan font-semibold">*{emailMsg}</p>
                )}

                {isEmailVerified && (
                    <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-2 w-full">
                            <input
                                ref={codeRef}
                                type="text"
                                className={`appearance-none text-gray-700 border ${codeError ? "border-red-500 placeholder-red-500 focus:outline-red-500" : "border-extra placeholder-gray-400 focus:outline-input"} rounded py-2 px-3 text-[13px] leading-tight focus:text-black`}
                                style={
                                    isMobile
                                        ? { width: "100%", maxWidth: "160px", height: "40px" }
                                        : { width: "100%", maxWidth: "160px", height: "46px" }
                                }
                                value={emailVerificationCode}
                                onChange={(e) => setEmailVerificationCode(e.target.value)}
                                placeholder="인증 코드"
                            />
                            <button
                                className={
                                    isMobile
                                        ? "w-[80px] h-[40px] bg-main font-namsan-B hover:bg-primary-80 border-main hover:border-primary-80 border-2 text-white text-[13px] rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-200"
                                        : "w-[64px] h-[38px] bg-main ml-3 font-namsan-B hover:bg-primary-80 border-main hover:border-primary-80 border-2 text-white py-1 px-2 text-[13px] rounded-full flex items-center justify-center transition-all duration-200"
                                }
                                type="button"
                                onClick={handleEmailVerificationCheck}
                            >
                                확인
                            </button>
                        </div>
                        {codeError && (
                            <p className="font-namsan text-[12px] font-bold text-red-500">
                                {codeError}
                            </p>
                        )}
                    </div>
                )}

                {isEmailCheck && (
                    <p className="mt-4 text-black font-namsan font-semibold">{emailCheck}</p>
                )}
                {!isEmailCheck && (
                    <p className="mt-4 text-red-500 font-namsan font-semibold">{emailCheck}</p>
                )}
                {!isEmailCheck && codeError && (
                    <p className="font-namsan text-[12px] font-bold text-red-500">{codeError}</p>
                )}
            </div>
        </label>
    );
};

export default EmailVerificationSection;
